import { Handle, Position } from '@xyflow/react'
import { INodeDescription } from '../../../definitions/NodesDescription'
import { NodeType } from '../../../definitions/Nodes'
import { useAppSelector } from '../../../store/Hooks'

interface P<T extends NodeType> {
    acceptedInput: INodeDescription<T>['acceptedInputs'][0]
    inputsCount: number
    index: number
}

function CustomInputHandle<T extends NodeType>({ acceptedInput, inputsCount, index }: P<T>) {
    if (!acceptedInput) return null

    const mode = useAppSelector(state => state.app.mode)
    const { argumentKey } = acceptedInput
    const range = 100
    const interval = range / (inputsCount + 1)
    const left = interval * (index + 1) + '%'
    return (
        <Handle
            type='target'
            id={String(argumentKey)}
            position={Position.Top}
            style={{ left: left }}>
            <div className='handle-label'>
                <div className={mode === 'dark' ? 'handle-label-text1' : 'handle-label-text1-input'}>
                    {argumentKey.toString()[0]}
                </div>
                <div className={mode === 'dark' ? 'handle-label-text2' : 'handle-label-text2-input'}>
                    {argumentKey.toString()}
                </div>
            </div>
        </Handle>
    )
}

export default CustomInputHandle
